export const Highlight = {
  mounted() {
    this.handleEvent("highlight", (params) => {
      if (this.el.id !== params.id) {
        return
      }

      const classList = this.el.classList
      const highlightClass = params.highlightClass || "highlighted"

      // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Tips#run_an_animation_again
      classList.remove("highlighted")

      window.requestAnimationFrame(function (time) {
        window.requestAnimationFrame(function (time) {
          classList.add(highlightClass)
        })
      })
    })
  },
}
